/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';

// import { ToastContainer, toast } from "react-toastify"; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)
// import Barcode from "react-barcode";
import MyTopCard from './MyTopCard';

class My extends Component {
  state = {
    tabIndex: 0,
  };
  _isMounted = false;
  componentDidMount = () => {
    this._isMounted = true;

    this._getData();
  };
  componentWillUnmount = () => {
    this._isMounted = false;
  };
  _getData = async () => {
    const { loginId } = this.props;

    if (loginId === null || loginId === undefined || loginId === '') {
    } else {
      const result = await this._getDataApi();
      if (result) {
        const intReturn = result.data[0].intReturn;
        const myInfoData = result.data[0].listData;
        //console.log(intReturn)
        //console.log(myInfoData)
        if (intReturn === 0) {
          if (intReturn === 0) {
            this.setState({
              myInfoData,
            });
          }
        }
      }
    }
  };
  getCookie = (name) => {
    var value = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');

    return value ? value[2] : null;
  };
  _getDataApi = () => {
    const { apiUrl, loginId, authId, history } = this.props;
    const at = this.getCookie('at');
    // const at = localStorage.getItem('at');

    return axios
      .post(
        apiUrl + '/mytopInfo',
        {
          params: {
            userid: loginId,
            authId: authId,
          },
        },
        {
          headers: {
            Authorization: 'bearer ' + at,
          },
        }
      )
      .then((response) => response)
      .catch((error) => {
        if (error.response.status === 403) {
          //console.log('refresh....token...')
          this._refreshToken();
        } else if (error.response.status === 400) {
          history.push('/login');
        }
        //alert('오류가 발생했습니다.')
      });
  };
  _refreshToken = async () => {
    const { history, apiUrl, setLoginId, setAuthId, loginId } = this.props;
    // const rt = localStorage.getItem('rt');
    const rt = this.getCookie('rt');
    if (rt === '' || rt === undefined || rt === null) {
      history.push('/login');
      return false;
    }

    const { data } = await axios.post(apiUrl + '/refreshToken', {
      params: {
        rt: rt,
        userid: loginId,
      },
    });

    if (data[0].intReturn === 0) {
      //console.log(data[0].at)
      localStorage.setItem('at', data[0].at);
      this._getData();
    } else {
      this.setCookie('account', '');

      setLoginId('');
      setAuthId('');

      setTimeout(() => {
        history.push('/login');
      }, 500);
    }
  };

  setCookie = (name, value, exp) => {
    let expires;
    if (exp) {
      var date = new Date();
      date.setTime(date.getTime() + exp * 24 * 60 * 60 * 1000);
      expires = date.toGMTString();
    } else {
      expires = '';
    }
    document.cookie =
      name +
      '=' +
      value +
      ';expires=' +
      expires +
      ';path=/; SameSite=None; Secure; domain=aniplustv.com';
  };

  _changeTabIndex = (tabIndex) => {
    const { onTabChange } = this.props.childProps;

    onTabChange(tabIndex);
  };
  _CommaFormatted = (str) => {
    ////console.log('aaaaaaaaaaaaaaaa')
    var Money;
    Money = '';
    while (parseInt(str) >= 1000) {
      if (parseInt(str) / 1000 > 0) {
        if (parseInt(str) % 1000 === 0) {
          Money = ',' + (parseInt(str) % 1000) + '00' + Money;
        } else {
          if (parseInt(str) % 1000 > 99)
            Money = ',' + (parseInt(str) % 1000) + Money;
          else if (parseInt(str) % 1000 > 9)
            Money = ',0' + (parseInt(str) % 1000) + Money;
          else Money = ',00' + (parseInt(str) % 1000) + Money;
        }
      }
      str = parseInt(str) / 1000;
    }
    Money = parseInt(str) + Money;

    return Money;
  };
  _onMove = (url) => {
    const { history } = this.props;
    history.push(url);
  };
  render() {
    const { myInfoData } = this.state;
    const { tabIndex } = this.props.childProps;
    const { imgUrl } = this.props;

    return (
      <Fragment>
        <div className="mypage_top2">
          {myInfoData ? (
            <Fragment>
              <dl>
                <dt>
                  <span>
                    {/*
                                <Barcode 
                                    value={myInfoData[0].barcode}
                                    displayValue={false}
                                    height={20}
                                    format="CODE128"
                                    fontSize={8}
                                    margin={2}
                                    textMargin={1}
                                    width={1}
                                />
                                */}
                    {/*<img src="/img/mypage/barcode.png"/>*/}
                  </span>
                  <div>
                    <img src={myInfoData[0].charac_Img} />
                  </div>
                </dt>
                <dd>
                  <h1>
                    {myInfoData[0].nicName}님 활동내역
                    <span>
                      <a
                        style={{ cursor: 'pointer' }}
                        onClick={() => this._onMove('/edit')}
                      >
                        회원정보 수정
                      </a>
                      <a
                        style={{ cursor: 'pointer' }}
                        onClick={() => this._onMove('/profile')}
                      >
                        프로필 변경
                      </a>
                    </span>
                  </h1>

                  {myInfoData[0].memberShipEndDate === '' ||
                  myInfoData[0].memberShipEndDate === '미보유' ||
                  myInfoData[0].memberShipEndDate === null ||
                  myInfoData[0].memberShipEndDate === undefined ? null : (
                    <div>
                      <img src={imgUrl + '/img/cashcard/logo_img2.png'} />
                      <p>
                        멤버십 정기결제
                        <img src={imgUrl + '/img/cashcard/13.png'} />
                      </p>
                      <span>
                        {'(~' + myInfoData[0].memberShipEndDate + ' 까지)'}
                      </span>
                    </div>
                  )}
                  {/*myInfoData[0].cash >= 0 ? (
                                    <div>
                                        <p>보유 포인트</p>
                                        <span>{this._CommaFormatted(myInfoData[0].cash)}원</span>
                                    </div>
                                ) : null */}
                </dd>
              </dl>
              <MyTopCard />
            </Fragment>
          ) : null}

          <div className="mypage_tab mypage_tab2">
            <div>
              <a
                style={{ cursor: 'pointer' }}
                className={tabIndex === 0 ? 'on' : null}
                onClick={() => this._changeTabIndex(0)}
              >
                찜한 작품
              </a>
              {/*<a style={{ cursor: 'pointer'}} className={tabIndex === 1 ? 'on' : null } onClick={()=>this._changeTabIndex(1)}>라이브 예약</a>*/}

              <a
                style={{ cursor: 'pointer' }}
                className={tabIndex === 2 ? 'on' : null}
                onClick={() => this._changeTabIndex(2)}
              >
                관람 중인 작품
              </a>
              <a
                style={{ cursor: 'pointer' }}
                className={tabIndex === 3 ? 'on' : null}
                onClick={() => this._changeTabIndex(3)}
              >
                다운로드한 작품
              </a>
              <a
                style={{ cursor: 'pointer' }}
                className={tabIndex === 1 ? 'on' : null}
                onClick={() => this._changeTabIndex(1)}
              >
                멤버십 내역
              </a>
              <a
                style={{ cursor: 'pointer' }}
                className={tabIndex === 4 ? 'on' : null}
                onClick={() => this._changeTabIndex(4)}
              >
                포인트 내역
              </a>
              {/*<a style={{ cursor: 'pointer'}} className={tabIndex === 5 ? 'on' : null } onClick={()=>this._changeTabIndex(5)}>나의 포인트카드</a>*/}
              <a
                style={{ cursor: 'pointer' }}
                className={tabIndex === 6 ? 'on' : null}
                onClick={() => this._changeTabIndex(6)}
              >
                작성한 리뷰
              </a>
              <a
                style={{ cursor: 'pointer' }}
                className={tabIndex === 7 ? 'on' : null}
                onClick={() => this._changeTabIndex(7)}
              >
                문의내역
              </a>
            </div>
          </div>
          <div className="mypage_right_bg"></div>
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(My));
